import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../_reducers/auth.reducers';

const getAuthFeatureState = createFeatureSelector<AuthState>('auth');

/**
 * Select token
 */
export const getAuth = createSelector(getAuthFeatureState, (state: AuthState) =>
  state ? state.token : null
);

/**
 * Select userData
 */
export const getUserData = createSelector(
  getAuthFeatureState,
  (state: AuthState) => (state ? state.userData : null)
);

/**
 * Select validTokenData
 */
export const getValidTokenData = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.validateToken
);

/**
 * Select appLoginInfo
 */
 export const getAppLoginInfo = createSelector(
  getAuthFeatureState,
  (state: AuthState) => (state ? state.appInfoResponse : null)
);

/**
 * Select error
 */
export const getAuthError = createSelector(
  getAuthFeatureState,
  (state: AuthState) => (state ? state.error : null)
);

/**
 * Select login Response
 */
export const getLoginResponse = createSelector(
  getAuthFeatureState,
  (state: AuthState) => (state ? state.loginResponse : null)
);
/**
 * Select login Response
 */
export const getLoginErrorResponse = createSelector(
  getAuthFeatureState,
  (state: AuthState) => (state ? state.loginError : null)
);

/**
 * Select operations
 */
export const getAuthOperations = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.operations
);
